(function polyfill() {
  const relList = document.createElement("link").relList;
  if (relList && relList.supports && relList.supports("modulepreload")) {
    return;
  }
  for (const link of document.querySelectorAll('link[rel="modulepreload"]')) {
    processPreload(link);
  }
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type !== "childList") {
        continue;
      }
      for (const node of mutation.addedNodes) {
        if (node.tagName === "LINK" && node.rel === "modulepreload")
          processPreload(node);
      }
    }
  }).observe(document, { childList: true, subtree: true });
  function getFetchOpts(link) {
    const fetchOpts = {};
    if (link.integrity)
      fetchOpts.integrity = link.integrity;
    if (link.referrerPolicy)
      fetchOpts.referrerPolicy = link.referrerPolicy;
    if (link.crossOrigin === "use-credentials")
      fetchOpts.credentials = "include";
    else if (link.crossOrigin === "anonymous")
      fetchOpts.credentials = "omit";
    else
      fetchOpts.credentials = "same-origin";
    return fetchOpts;
  }
  function processPreload(link) {
    if (link.ep)
      return;
    link.ep = true;
    const fetchOpts = getFetchOpts(link);
    fetch(link.href, fetchOpts);
  }
})();
const style = "";
document.addEventListener("DOMContentLoaded", () => {
  const videos = document.querySelectorAll(".video[data-src]");
  if (!videos.length) {
    return;
  }
  const pickSuffix = (width) => width <= 768 ? "_sm" : "_lg";
  const updateVideoSource = (video, suffix, forcePlay = false) => {
    const baseSrc = video.dataset.src;
    if (!baseSrc) {
      return;
    }
    video.muted = true;
    video.playsInline = true;
    const targetSrc = `${baseSrc}${suffix}.mp4`;
    let source = video.querySelector('source[data-responsive-src="true"]');
    if (!source) {
      source = document.createElement("source");
      source.setAttribute("type", "video/mp4");
      source.setAttribute("data-responsive-src", "true");
      video.appendChild(source);
    }
    if (source.getAttribute("src") === targetSrc) {
      return;
    }
    const wasPlaying = !video.paused && !video.ended;
    source.setAttribute("src", targetSrc);
    video.load();
    if (wasPlaying || forcePlay) {
      video.play().catch(() => {
      });
    }
  };
  let currentSuffix = pickSuffix(window.innerWidth);
  videos.forEach((video) => updateVideoSource(video, currentSuffix, true));
  window.addEventListener("resize", () => {
    const nextSuffix = pickSuffix(window.innerWidth);
    if (nextSuffix === currentSuffix) {
      return;
    }
    currentSuffix = nextSuffix;
    videos.forEach((video) => updateVideoSource(video, currentSuffix));
  });
});
const SWAP_ROOT_SELECTOR = ".js-swap";
const IMAGE_ONE_SELECTOR = ".-img01";
const IMAGE_TWO_SELECTOR = ".-img02";
const initializedSwapRoots = /* @__PURE__ */ new WeakSet();
const collectSwapRoots = (scope) => {
  const roots = /* @__PURE__ */ new Set();
  if (scope instanceof Element && scope.matches(SWAP_ROOT_SELECTOR)) {
    roots.add(scope);
  }
  scope.querySelectorAll(SWAP_ROOT_SELECTOR).forEach((swapRoot) => {
    roots.add(swapRoot);
  });
  scope.querySelectorAll(IMAGE_ONE_SELECTOR).forEach((imageOne) => {
    const nearestSwapRoot = imageOne.closest(SWAP_ROOT_SELECTOR);
    if (nearestSwapRoot) {
      roots.add(nearestSwapRoot);
      return;
    }
    const fallbackRoot = imageOne.parentElement;
    if (!fallbackRoot || !fallbackRoot.querySelector(IMAGE_TWO_SELECTOR)) {
      return;
    }
    roots.add(fallbackRoot);
  });
  return Array.from(roots);
};
const applySwapState = (imageOne, imageTwo, isSwapped) => {
  imageOne.style.opacity = isSwapped ? "0" : "1";
  imageTwo.style.opacity = isSwapped ? "1" : "0";
  imageOne.style.zIndex = isSwapped ? "1" : "2";
  imageTwo.style.zIndex = isSwapped ? "2" : "1";
};
const setupSwap = (swapRoot) => {
  if (initializedSwapRoots.has(swapRoot)) {
    return;
  }
  const imageOne = swapRoot.querySelector(IMAGE_ONE_SELECTOR) || swapRoot.querySelector("img:first-of-type");
  const imageTwo = swapRoot.querySelector(IMAGE_TWO_SELECTOR) || swapRoot.querySelector("img:nth-of-type(2)");
  if (!imageOne || !imageTwo || imageOne === imageTwo) {
    return;
  }
  initializedSwapRoots.add(swapRoot);
  let isHovering = false;
  let isClickFlipped = false;
  imageOne.style.transition = imageOne.style.transition || "opacity 0.3s ease";
  imageTwo.style.transition = imageTwo.style.transition || "opacity 0.3s ease";
  imageOne.style.willChange = "opacity";
  imageTwo.style.willChange = "opacity";
  const setSwapped = (isSwapped) => {
    applySwapState(imageOne, imageTwo, isSwapped);
    swapRoot.classList.toggle("is-swapped", isSwapped);
  };
  const syncSwapState = () => {
    const isSwapped = isHovering ? !isClickFlipped : false;
    setSwapped(isSwapped);
  };
  setSwapped(false);
  swapRoot.addEventListener("mouseenter", () => {
    isHovering = true;
    isClickFlipped = false;
    syncSwapState();
  });
  swapRoot.addEventListener("mouseleave", () => {
    isHovering = false;
    isClickFlipped = false;
    syncSwapState();
  });
  swapRoot.addEventListener("click", () => {
    if (!isHovering) {
      setSwapped(!swapRoot.classList.contains("is-swapped"));
      return;
    }
    isClickFlipped = !isClickFlipped;
    syncSwapState();
  });
};
const initSwap = (scope = document) => {
  const swapRoots = collectSwapRoots(scope);
  swapRoots.forEach(setupSwap);
};
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    initSwap(document);
  });
} else {
  initSwap(document);
}
document.addEventListener("shopify:section:load", (event) => {
  if (event.target instanceof Element) {
    initSwap(event.target);
  }
});
const VOLUME_BUTTON_SELECTOR = ".top-video .js-vol";
const VOLUME_BUTTON_INITIALIZED = "data-volume-button-initialized";
const syncVolumeButtonState = (button, video) => {
  button.classList.toggle("is-play", !video.muted);
};
const findTopVideo = (button) => {
  const root = button.closest(".top-video");
  if (!root) {
    return null;
  }
  return root.querySelector("video");
};
const handleVolumeToggle = (button) => {
  const video = findTopVideo(button);
  if (!video) {
    return;
  }
  video.muted = !video.muted;
  syncVolumeButtonState(button, video);
};
const initTopVideoVolumeButtons = (scope = document) => {
  const buttons = scope.querySelectorAll(VOLUME_BUTTON_SELECTOR);
  buttons.forEach((button) => {
    if (!(button instanceof HTMLElement)) {
      return;
    }
    if (button.hasAttribute(VOLUME_BUTTON_INITIALIZED)) {
      const video = findTopVideo(button);
      if (video) {
        syncVolumeButtonState(button, video);
      }
      return;
    }
    button.setAttribute(VOLUME_BUTTON_INITIALIZED, "true");
    button.setAttribute("role", "button");
    button.setAttribute("tabindex", "0");
    button.setAttribute("aria-label", "Toggle video sound");
    const video = findTopVideo(button);
    if (video) {
      syncVolumeButtonState(button, video);
    }
    button.addEventListener("click", () => {
      handleVolumeToggle(button);
    });
    button.addEventListener("keydown", (event) => {
      if (event.key !== "Enter" && event.key !== " ") {
        return;
      }
      event.preventDefault();
      handleVolumeToggle(button);
    });
  });
};
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    initTopVideoVolumeButtons(document);
  });
} else {
  initTopVideoVolumeButtons(document);
}
document.addEventListener("shopify:section:load", (event) => {
  if (event.target instanceof Element) {
    initTopVideoVolumeButtons(event.target);
  }
});
